import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowUp,
  faClipboard,
  faDoorOpen,
  faDotCircle,
  faCircleCheck,
  faCircleQuestion,
  faStarHalf,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import { memo, useState } from 'react';

import NestedDataList from '@/components/NestedDataList';
import { Color } from '@/constants/color';
import Badge from '@/ui/components/Badge';
import Button from '@/ui/components/Button';
import ListCard from '@/ui/components/ListCard';
import snakeToTitleCase from '@/utils/snakeToTitleCase';

import { Props } from './types';

const statusColorMap: { [key: string]: Color } = {
  active: Color.GREEN,
  discharged: Color.RED,
  intake: Color.TEAL,
  lead: Color.INDIGO,
  not_qualified: Color.GRAY,
  partial_lead: Color.CYAN,
  prospect: Color.YELLOW,
  qualified_lead: Color.BLUE
};

const statusIconMap: { [key: string]: IconProp } = {
  active: faCircleCheck,
  discharged: faDoorOpen,
  intake: faClipboard,
  lead: faArrowUp,
  not_qualified: faTimesCircle,
  partial_lead: faStarHalf,
  prospect: faCircleQuestion,
  qualified_lead: faDotCircle
};

const ProgramQualificationItem = ({ programQualification }: Props) => {
  const [showAllDetails, setShowAllDetails] = useState(false);
  const color = statusColorMap[programQualification.status] || Color.GRAY;

  return (
    <ListCard
      debug={programQualification}
      headingIcon={statusIconMap[programQualification.status] || faCircleQuestion}
      headingIconClassName={`text-${color}-700`}
      subtitle={programQualification.primary_substance || 'No Primary Substance'}
      subtitleSensitive={!!programQualification.primary_substance}
      timestamp={{
        datetime: programQualification.created_at,
        prefix: 'Created at'
      }}
      title={
        programQualification.default_program?.name ||
        programQualification.selected_program?.name ||
        'No Program'
      }>
      <div className="flex gap-1">
        {programQualification.status && (
          <Badge color={color} text={snakeToTitleCase(programQualification.status)} />
        )}
      </div>

      <Button
        className="mt-2"
        color={Color.WHITE}
        onClick={() => setShowAllDetails(!showAllDetails)}
        size="xs">
        {showAllDetails ? 'Hide Details' : 'Show All Details'}
      </Button>

      {showAllDetails && <NestedDataList data={programQualification} sensitive />}
    </ListCard>
  );
};

export default memo(ProgramQualificationItem);
